module.exports = __webpack_public_path__ + "static/bsas013.thumb-26edb11aa7b1a19e58370e689ba2719f.jpg";